import { useLang } from '@/hooks/useLang';

const copy = {
  EN: {
    tagline: 'AI-powered content creation system.',
    links: [
      { label: 'Work', href: '#showreel' },
      { label: 'Services', href: '#what-we-build' },
      { label: 'Process', href: '#how-it-works' },
      { label: 'Technology', href: '#technology' },
      { label: 'Contact', href: '#contact' },
    ],
    legal: ['Privacy Policy', 'Terms of Use'],
    copy: '© 2025 KODO. All rights reserved.',
  },
  TR: {
    tagline: 'Yapay zeka destekli içerik üretim sistemi.',
    links: [
      { label: 'Çalışmalar', href: '#showreel' },
      { label: 'Hizmetler', href: '#what-we-build' },
      { label: 'Süreç', href: '#how-it-works' },
      { label: 'Teknoloji', href: '#technology' },
      { label: 'İletişim', href: '#contact' },
    ],
    legal: ['Gizlilik Politikası', 'Kullanım Koşulları'],
    copy: '© 2025 KODO. Tüm hakları saklıdır.',
  },
};

export default function Footer() {
  const lang = useLang();
  const t = copy[lang];

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-white border-t border-gray-100 py-16">
      <div className="max-w-[1400px] mx-auto px-8 md:px-16">
        <div className="flex flex-col md:flex-row items-start justify-between gap-10 mb-12">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <img
                src="https://static.readdy.ai/image/5f8ccebbf933f3139676e12de0a0cc44/d3727af9a4e2ead3ec34f38cdcccd26f.png"
                alt="KODO"
                className="h-8 w-auto object-contain"
              />
              <span className="text-gray-900 text-xl font-black tracking-widest uppercase" style={{ fontFamily: '\'Space Grotesk\', sans-serif' }}>
                KODO
              </span>
            </div>
            <p className="text-sm text-gray-400 max-w-xs leading-relaxed">{t.tagline}</p>
          </div>

          {/* Nav links */}
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {t.links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                className="text-sm text-gray-400 hover:text-gray-900 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-gray-50">
          <p className="text-xs text-gray-300">{t.copy}</p>
          <div className="flex gap-6">
            {t.legal.map((item) => (
              <a key={item} href="#" className="text-xs text-gray-300 hover:text-gray-500 transition-colors cursor-pointer whitespace-nowrap">
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
